import { Route, Routes } from "react-router-dom";
import Balance from "./components/Balance";
import Form from "./components/Form";
import Layout from "./components/Layout";
import AllTransacion from "./components/Transactions/AllTransacion";
import Transactions from "./components/Transactions/Transactions";

function App() {
    return (
        <Routes>
            <Route
                path="/"
                element={
                    <Layout>
                        <Balance />
                        <Form>Add New Transaction</Form>
                        <Transactions />
                    </Layout>
                }
            />
            <Route path="/allTransaction" element={<AllTransacion />} />
        </Routes>
    );
}

export default App;
